import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { CategorySelector } from "./components/CategorySelector";
import { WhatWeHandle } from "./components/WhatWeHandle";
import { HowItWorks } from "./components/HowItWorks";
import { HumanTrust } from "./components/HumanTrust";
import { Pricing } from "./components/Pricing";
import { NotForYou } from "./components/NotForYou";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { AdminDashboard } from "./components/AdminDashboard";

// Main landing page - Visual-first, choice-led
const LandingPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <CategorySelector />
        <div id="what-we-do">
          <WhatWeHandle />
        </div>
        <HowItWorks />
        <HumanTrust />
        <div id="pricing">
          <Pricing />
        </div>
        {/* Mobile only: Not for you after pricing */}
        <div className="sm:hidden">
          <NotForYou />
        </div>
        <Contact />
        {/* Desktop: Not for you after contact */}
        <div className="hidden sm:block">
          <NotForYou />
        </div>
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/admin/enquiries" element={<AdminDashboard />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
